import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_close_circle",
  "use": "icon-icon_close_circle-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-icon_close_circle\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h18v18H0z\" /><path d=\"M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14Z\" fill=\"#D1D2DD\" /><path stroke=\"#FFF\" stroke-width=\"1.333\" stroke-linecap=\"square\" d=\"m11 7-4 4M7 7l4 4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol